import React from 'react';
import { Card, Typography, Space, Breadcrumb, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

const { Text } = Typography;

export default function SelectPage({ scannedItem, onNavigate }) {
  const { t } = useTranslation();
  const receiptItems = scannedItem?.receipt_items || [];

  return (
    <div>
      <Breadcrumb style={{ marginBottom: 16 }}
        items={[
          { title: <a onClick={() => onNavigate('mode')}>{t('operator.inbound_item.select_mode')}</a> },
          { title: t('operator.inbound_item.select_receipt_item') },
        ]}
      />

      <Space direction="vertical" style={{ width: '100%' }} size={8}>
        {receiptItems.map((ri, idx) => {
          // 已上架的收貨紀錄不可修正：實體已在架上，把驗收數量改小會違反
          // putaway + adjusted ≤ quantity 的不變式（後端會 raise），所以這裡直接停用。
          const isPutaway = (ri.putaway_quantity ?? 0) > 0;
          const card = (
            <Card
              key={ri.id}
              hoverable={!isPutaway}
              size="small"
              style={isPutaway ? { opacity: 0.5, cursor: 'not-allowed' } : { cursor: 'pointer' }}
              onClick={isPutaway ? undefined : () => onNavigate('form', { mode: 'edit', editingReceiptItem: ri })}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Space size="large">
                  <Text strong>#{idx + 1}</Text>
                  <div>
                    <div>
                      <Text strong>{ri.quantity}</Text> {t('models.receipt_item.quantity_unit', { defaultValue: '件' })}
                    </div>
                    <Space size="small" style={{ fontSize: 12, color: '#666' }}>
                      {ri.batch && <span>Batch: {ri.batch}</span>}
                      {ri.expiration_date && <span>Exp: {dayjs(ri.expiration_date).format('YYYY-MM-DD')}</span>}
                    </Space>
                  </div>
                </Space>
                <div style={{ textAlign: 'right' }}>
                  <Text type="secondary" style={{ fontSize: 12 }}>{ri.verifier_name || '-'}</Text>
                  <div style={{ fontSize: 11, color: '#999' }}>
                    {ri.received_at ? dayjs(ri.received_at).format('MM-DD HH:mm') : '-'}
                  </div>
                </div>
              </div>
            </Card>
          );

          return isPutaway ? (
            <Tooltip key={ri.id} title={t('operator.inbound_item.mode_edit_disabled_putaway')}>
              {card}
            </Tooltip>
          ) : card;
        })}
      </Space>
    </div>
  );
}
